import ColumnText from "../molecules/ColumnText";
import { Fragment } from "react";
import { Empty } from "./Empty";
import ColumnPersonInformationAvatar from "../molecules/ColumnPersonInformationAvatar";
import { t } from "i18next";
import { User } from "@/app/auth/auth";

export type TableListUsersActivitysProps = {
  users?: Array<User>;
  onClickEmpty?: () => void;
};

const TableListUsersActivitys: React.FC<TableListUsersActivitysProps> = ({
  users = [],
  onClickEmpty,
}) => {
  return (
    <div className="mt-2">
      <div className="sm:flex sm:items-center justify-between">
        <div className="flex-grow">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            {t("lesson.views.users")}
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            {t("lesson.views.list_users")}
          </p>
        </div>
      </div>
      <div className="border-b border-gray-300 mt-5"></div>
      <div className="flow-root">
        {/* Añadir un contenedor con scroll */}
        <div className="overflow-x-auto max-h-[60vh]">
          <div className="inline-block min-w-full align-middle">
            {users.length === 0 ? (
              <Empty
                onClick={onClickEmpty}
                texto={t("lesson.views.no_users")}
              />
            ) : (
              <Fragment>
                <table className="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("lesson.views.name")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("lesson.views.phone")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("lesson.views.status")}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {users.map((user) => (
                      <tr key={user.id}>
                        <ColumnPersonInformationAvatar
                          id={Number(user.id)}
                          name={user.name}
                          image={user.image}
                          email={user.email}
                        />
                        <ColumnText title={user.phone} />
                        <ColumnText title={user.state} />
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableListUsersActivitys;
